// Coordinates the OAuth /callback page's in-flight session request with a
// logout started elsewhere (the invalid-outcome path inside /callback itself,
// or navigating away to /logout while refreshAuthServiceSession() is still
// pending). Neither of those can rely on the /callback component's own
// unmount cleanup: a plain unmount (e.g. the page re-rendering) must still
// let a pending login through, but an explicit logout must not.
let cancelled = false;

export function beginCallbackSessionAttempt(): void {
  cancelled = false;
}

export function cancelPendingCallbackSession(): void {
  cancelled = true;
}

export function isPendingCallbackSessionCancelled(): boolean {
  return cancelled;
}
